//--- ARQUIVO COMPLETO: BudgetPDFView.js (Copie e cole tudo) ---
import React from 'react';

export const BudgetPDFView = ({ budget, meiInfo, client, onClose }) => {
    const formatCurrency = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);
    const formatDate = (dateString) => new Date(dateString + 'T00:00:00').toLocaleDateString('pt-BR');

    const handlePrint = () => {
        const printContents = document.getElementById('printable-area').innerHTML;
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';
        document.body.appendChild(iframe);
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        doc.open();
        doc.write(`<html><head><title></title><script src="https://cdn.tailwindcss.com"></script><style>@page { size: A4; margin: 1.5cm; } body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }</style></head><body>${printContents}</body></html>`);
        doc.close();
        iframe.onload = function() { setTimeout(function() { iframe.contentWindow.focus(); iframe.contentWindow.print(); document.body.removeChild(iframe); }, 250); };
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-2xl w-full max-w-4xl flex flex-col max-h-[90vh]">
                <div id="printable-area" className="p-8 overflow-y-auto">
                    <header className="flex justify-between items-start pb-4 border-b border-gray-300">
                        <div className="w-1/2">
                            <h2 className="font-bold text-xl text-gray-800">{meiInfo.nome}</h2>
                            <p className="text-sm text-gray-600">CNPJ: {meiInfo.cnpj}</p>
                        </div>
                        <div className="text-right w-1/2">
                            <h1 className="font-bold text-2xl uppercase text-gray-800">Orçamento</h1>
                            <p className="text-sm text-gray-600">
                                Número: {budget.budgetNumber ? String(budget.budgetNumber).padStart(4, '0') : budget.id.substring(0, 8).toUpperCase()}
                            </p>
                            <p className="text-sm text-gray-600">Data de Emissão: {formatDate(budget.dataCriacao)}</p>
                            <p className="text-sm text-gray-600">Válido até: {formatDate(budget.validade)}</p>
                        </div>
                    </header>
                    <section className="my-8 p-4 bg-gray-50 rounded-md">
                        <h3 className="font-bold mb-2 text-gray-700">Para:</h3>
                        <p className="font-semibold text-gray-800">{client.nome}</p>
                        {client.cpf_cnpj && <p className="text-gray-600">{client.cpf_cnpj}</p>}
                        {client.email && <p className="text-gray-600">{client.email}</p>}
                        {client.telefone && <p className="text-gray-600">{client.telefone}</p>}
                        {client.logradouro && <p className="text-gray-600">{client.logradouro}, {client.numero} - {client.bairro}, {client.cidade}</p>}
                    </section>
                    <section>
                        <table className="w-full text-left border-collapse text-sm">
                            <thead className="bg-gray-200">
                                <tr>
                                    <th className="p-2 border-y border-gray-300 font-semibold text-gray-700">Descrição</th>
                                    <th className="p-2 border-y border-gray-300 font-semibold text-gray-700 text-center w-24">Qtd.</th>
                                    <th className="p-2 border-y border-gray-300 font-semibold text-gray-700 text-right w-32">Preço Unit.</th>
                                    <th className="p-2 border-y border-gray-300 font-semibold text-gray-700 text-right w-32">Subtotal</th>
                                </tr>
                            </thead>
                            <tbody>
                                {budget.items.map((item, index) => (
                                    <tr key={index} className="border-b border-gray-200">
                                        <td className="p-2 text-gray-800">{item.description}</td>
                                        <td className="p-2 text-gray-800 text-center">{item.quantity}</td>
                                        <td className="p-2 text-gray-800 text-right">{formatCurrency(item.price)}</td>
                                        <td className="p-2 text-gray-800 text-right">{formatCurrency(item.quantity * item.price)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </section>
                    <section className="flex justify-end mt-4">
                        <div className="w-auto min-w-[250px]">
                            <div className="flex justify-between items-center bg-gray-200 p-3 rounded-md">
                                <span className="font-bold text-lg text-gray-800">TOTAL:</span>
                                <span className="font-bold text-lg text-gray-800">{formatCurrency(budget.total)}</span>
                            </div>
                        </div>
                    </section>
                    <footer className="mt-12 text-center text-xs text-gray-500">
                        <p>Obrigado pela sua preferência!</p>
                    </footer>
                </div>
                <div className="mt-auto bg-gray-50 p-4 flex justify-end space-x-4">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300 text-gray-800">Fechar</button>
                    <button onClick={handlePrint} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">Imprimir / Salvar PDF</button>
                </div>
            </div>
        </div>
    );
};